import React from 'react';

const Loader = ({ error, pastDelay }) => {
  if (error) {
  	console.log(error);
    return <div>Произошла ошибка!</div>;
  } else if (pastDelay) {
    return <div />;
  }

  return null;
};

export default Loader;